var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "10px",
    viewBox: "0 0 16 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Games/Questions-options",
    transform: "translate(-1100.000000, -501.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Section/TableBox",
    transform: "translate(340.000000, 108.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(50.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dropdown-Options",
    transform: "translate(687.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99953695,0 C4.6982342,0 2.1498555,2.33741317 0.913107292,3.70572279 C0.389725186,4.28475025 0.0897991921,4.7138604 0.0897991921,4.7138604 C-0.029933064,4.88534568 -0.029933064,5.11465432 0.0897991921,5.2861396 C0.0897991921,5.2861396 0.325823883,5.62434668 0.739263994,6.09884221 C1.90007153,7.43102878 4.53510727,10 7.99953695,10 C11.5556511,10 14.2413581,7.29579888 15.3525528,5.99536884 C15.7093681,5.57763811 15.9102008,5.2861396 15.9102008,5.2861396 C16.0299331,5.11465432 16.0299331,4.88534568 15.9102008,4.7138604 C15.9102008,4.7138604 15.6899199,4.39642739 15.3008232,3.94601389 C14.1601254,2.62613298 11.5024662,0 7.99953695,0 Z M7.99953695,1.00019848 C10.988742,1.00019848 13.4842004,3.37320543 14.5439301,4.59953688 C14.7560083,4.84498842 14.7759857,4.88415481 14.8651565,5.00191862 C14.7820716,5.11121403 14.7724136,5.13436983 14.5916907,5.34581542 C13.560538,6.552696 11.0341212,8.99980152 7.99953695,8.99980152 C5.04314248,8.99980152 2.57149827,6.67998677 1.49218805,5.44148197 C1.26039699,5.17552101 1.23552443,5.12616606 1.14159083,5.00191862 C1.25034212,4.8567648 1.31913856,4.74852795 1.65438887,4.37777043 C2.80633225,3.10314257 5.18232295,1.00019848 7.99953695,1.00019848 Z M7.99953695,2.00039696 C6.34842252,2.00039696 5.00226152,3.34674165 5.00226152,4.99808138 C5.00226152,6.64928879 6.34842252,7.99960304 7.99953695,7.99960304 C9.65051907,7.99960304 11.0006491,6.64928879 11.0006491,4.99808138 C11.0006491,3.34674165 9.65051907,2.00039696 7.99953695,2.00039696 Z",
    id: "Shape"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeNew);
export default __webpack_public_path__ + "static/media/eye-new.a4b8b155c9a66f36975c80a89452ccf8.svg";
export { ForwardRef as ReactComponent };